import { render, staticRenderFns } from "./StyleGuideModal.vue?vue&type=template&id=8b367bc8&scoped=true"
import script from "./StyleGuideModal.vue?vue&type=script&lang=js"
export * from "./StyleGuideModal.vue?vue&type=script&lang=js"
import style0 from "./StyleGuideModal.vue?vue&type=style&index=0&id=8b367bc8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b367bc8",
  null
  
)

export default component.exports